/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $CompanyGetTaxesResponse = {
  type: 'all-of',
  contains: [{
    type: 'Response',
  }, {
    properties: {
      data: {
        type: 'array',
        contains: {
          type: 'CompanyTax',
        },
      },
    },
  }],
} as const;
